'use strict';

angular.module('cloudBillingLegacyFrontend').controller('EaConfiguredAreaCtrl', [ '$scope', function ($scope) {

  // defined some view related information
  $scope.configured = false;  

}]);
